import { createActions, createReducer } from 'reduxsauce';
import { cloneDeep, forEach, set } from 'lodash';

export { default as thunks } from './thunks';

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	data        : [],
	minimalData : [],
	totalCount  : 0,
	filters     : {
		displayCount : 16,
		pageNumber   : 1,
	},
	loading : {
		data        : false,
		minimalData : false,
		activeJobs  : false,
		officers    : false,
		activity    : false,
	},
	details : {
		data       : {},
		activeJobs : {
			data       : [],
			totalCount : 0,
			filters    : {
				displayCount : 10,
				pageNumber   : 1,
			},
		},
		jobHistory : {
			data       : [],
			totalCount : 0,
			filters    : {
				displayCount : 10,
				pageNumber   : 1,
			},
		},
		officers : {
			data       : [],
			totalCount : 0,
			filters    : {
				displayCount : 10,
				pageNumber   : 1,
			},
		},
		activity : {
			data       : [],
			totalCount : 0,
			filters    : {
				pagingToken  : null,
				displayCount : 10,
				hasNext      : false,
			},
		},
	},
};

/* ------------- Types and Action Creators ------------- */
export const { Types, Creators } = createActions({
	setLoading           : ['property', 'value'],
	updateFilters        : ['propertyObject'],
	receiveData          : ['data', 'totalCount'],
	receiveMinimalData   : ['minimalData'],
	receiveDetails       : ['property', 'value'],
	receiveSectionData   : ['section', 'data', 'totalCount'],
	updateSectionFilters : ['section', 'propertyObject'],
	resetActivityData    : [],
}, { prefix : '@locations/' });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
	[Types.SET_LOADING] : (state, { property, value }) => ({
		...state,
		loading : {
			...state.loading,
			[property] : value,
		},
	}),

	[Types.UPDATE_FILTERS] : (state, { propertyObject }) => {
		const newState = cloneDeep(state);

		forEach(propertyObject, (value, property) => {
			set(newState, `filters.${property}`, value);
		});

		return newState;
	},

	[Types.RECEIVE_DATA] : (state, { data, totalCount }) => ({
		...state,
		data,
		totalCount,
	}),

	[Types.RECEIVE_MINIMAL_DATA] : (state, { minimalData }) => ({
		...state,
		minimalData,
	}),

	[Types.RECEIVE_DETAILS] : (state, { property, value }) => ({
		...state,
		details : {
			...state.details,
			[property] : value,
		},
	}),

	[Types.RECEIVE_SECTION_DATA] : (state, { section, data, totalCount }) => ({
		...state,
		details : {
			...state.details,
			[section] : {
				...state.details[section],
				data,
				totalCount,
			},
		},
	}),

	[Types.UPDATE_SECTION_FILTERS] : (state, { section, propertyObject }) => {
		const newState = cloneDeep(state);

		forEach(propertyObject, (value, property) => {
			set(newState, `details.${section}.filters.${property}`, value);
		});

		return newState;
	},

	[Types.RESET_ACTIVITY_DATA] : (state) => {
		const newState = cloneDeep(state);
		newState.details.activity = cloneDeep(INITIAL_STATE.details.activity);
		return newState;
	},
});

export default Creators;
